import Vue from "vue";
import App from "./App.vue";

import router from "@/router";
import store from "@/store";
import axios from "axios";
import Vuex from "vuex";

import BootstrapVue from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

require("@/store/subscriber");

//vue use
Vue.use(Vuex);
Vue.use(BootstrapVue);

axios.defaults.baseURL = "https://teaboardapi.sumato.tech/api/v1";
//  https://teaboardapi.sumato.tech/api/v1
//https://staging.teaboardchaisahyog.org/api/v1

Vue.config.productionTip = false;

store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount("#app");
});
